import React, { useEffect, useRef, useState } from 'react';
import { FetchError } from '../../../common/api/api';
import ExportButton from '../../../common/ExportButton';
import { useCheckIfHasTemplate } from '../../template/Template.hooks';
import { TemplateType } from '../../template/Template.interface';
import { useExportChangeOrderDocument } from '../ChangeOrder.hook';
import { ChangeOrder } from '../ChangeOrder.interface';

export interface ChangeOrderExportButtonProps {
  changeOrder: ChangeOrder;
  error?: (error: FetchError) => void;
}

const ChangeOrderExportButton: React.FC<
  ChangeOrderExportButtonProps
> = props => {
  const { changeOrder, error } = props;
  const [templateAvailable, setTemplateAvailable] = useState(false);
  const extensionRef = useRef<'docx' | 'pdf'>('docx');
  const [
    { isLoading, error: exportError, response },
    getDocument,
    downloadDocument
  ] = useExportChangeOrderDocument(changeOrder.id);

  const [{ data: ifHasTemplate }, get] = useCheckIfHasTemplate(
    TemplateType.Risk
  );

  const getDocumentAs = (extension: 'docx' | 'pdf') => {
    extensionRef.current = extension;
    getDocument(extension);
  };

  useEffect(() => {
    if (response?.ok) {
      downloadDocument(`CO-${changeOrder.id}.${extensionRef.current}`);
    }
  }, [response]);

  useEffect(() => {
    if (ifHasTemplate) {
      setTemplateAvailable(true);
    } else {
      setTemplateAvailable(false);
    }
  }, [ifHasTemplate]);

  useEffect(() => {
    get();
  }, [get]);

  useEffect(() => {
    exportError && error?.(exportError);
  }, [exportError]);

  return (
    <ExportButton
      templateAvailable={templateAvailable}
      isLoading={isLoading}
      hasOption={true}
      onClick={extension => extension && getDocumentAs(extension)}
    />
  );
};
export default ChangeOrderExportButton;
